import { createSlice } from '@reduxjs/toolkit'
const lang = window.localStorage.getItem("lang");

const initialState = {
  language: lang?? "fr"
}

export const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    changeLanguage: (state, action) => {
      state.language = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { changeLanguage } = localeSlice.actions

export default localeSlice.reducer